import { PaymentMethodCode, type PaymentOption } from '@src/domains/payments/types/payment';

export const isCreditCardOption = (paymentOption?: PaymentOption): boolean =>
  paymentOption?.paymentMethod.code === PaymentMethodCode.CreditCard;
